// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { loadCDLV3Script } from '@makemydeal/dr-common-data-layer-utils';

// interfaces/types
import type { ReduxMiddleware, ReduxNext } from '@makemydeal/dr-shared-store';
import { bridgeUserActionTypes } from '@makemydeal/dr-shared-store';
import {
    HostEnvironment,
    hostUrlHelper,
    locHrefUtil,
    offerSessionUtils,
    SALES_CHECKIN_APP_PREFIX
} from '@makemydeal/dr-shared-ui-utils';

export const loadCdlV3ScriptMiddleware: ReduxMiddleware<any> = () => (next: ReduxNext) => (action: AnyFSA) => {
    next(action);
    switch (action.type) {
        case bridgeUserActionTypes.BRIDGE_USER_SUCCESS: {
            const environment = hostUrlHelper.getHostUrlEnvironment(SALES_CHECKIN_APP_PREFIX, locHrefUtil.getLocHref());
            const env = environment === HostEnvironment.Prod ? 'prod' : 'non-prod';
            if (offerSessionUtils.isCrmEmbeddedMode()) {
                (window as any).PixallConfig = { ...(window as any).PixallConfig, sendToParent: true };
            }
            loadCDLV3Script(env);
            break;
        }
    }
};
